
import { defineComponent, type PropType } from 'vue';
import { ITrailReactionModel } from '@/types/routewebmodel';

export default defineComponent({
  name: 'TrailReactions',
  props: {
    reactions: {
      type: Array as PropType<Array<ITrailReactionModel>>,
      required: true,
    },
  },
  computed: {
    listTitle() {
      return `${this.reactions.length} ${(this.reactions.length !== 1 ? 'reacties' : 'reactie')}`;
    },
  },
});
